import React from 'react';
import { t } from 'i18next';
import styles from './JobseekerFeaturesUi.module.css';
import { FaCheck, FaTimes } from 'react-icons/fa';

const JobseekerFeaturesUi = ({ 
    planName,
    verifiedBadge,
    exclusiveJob,
    uploadMultipleCVs,
    increasedVisibility,
    instantNotification,
    showHidePhoto,
    directMessage,
    profileInsights,
    isPaused
}) => {
    
    const featuresData = [
        {
            name: t('jobseekerFeatures.verifiedBadge', 'Verified Badge'),
            value: verifiedBadge ? <FaCheck className={styles.checkIcon} /> : <FaTimes className={styles.crossIcon} />
        },
        {
            name: t('jobseekerFeatures.exclusiveJob', 'Exclusive Job'),
            value: exclusiveJob ? <FaCheck className={styles.checkIcon} /> : <FaTimes className={styles.crossIcon} />
        },
        {
            name: t('jobseekerFeatures.uploadMultipleCVs', 'Upload Multiple CVs and Cover Letter'),
            value: uploadMultipleCVs ? <FaCheck className={styles.checkIcon} /> : <FaTimes className={styles.crossIcon} />
        },
        {
            name: t('jobseekerFeatures.increasedVisibility', 'Increased Profile Visibility'),
            value: increasedVisibility ? <FaCheck className={styles.checkIcon} /> : <FaTimes className={styles.crossIcon} />
        },
        {
            name: t('jobseekerFeatures.instantNotification', 'Instant New Job Notification'),
            value: instantNotification ? <FaCheck className={styles.checkIcon} /> : <FaTimes className={styles.crossIcon} />
        },
        {
            name: t('jobseekerFeatures.showHidePhoto', 'Show/Hide Profile Photo'),
            value: showHidePhoto ? <FaCheck className={styles.checkIcon} /> : <FaTimes className={styles.crossIcon} />
        },
        {
            name: t('jobseekerFeatures.directMessage', 'Direct Message to Employer'),
            value: directMessage ? <FaCheck className={styles.checkIcon} /> : <FaTimes className={styles.crossIcon} />
        },
        {
            name: t('jobseekerFeatures.profileInsights', 'Profile Insights'),
            value: profileInsights ? <FaCheck className={styles.checkIcon} /> : <FaTimes className={styles.crossIcon} />
        }
    ];

    return (
        <div className={styles.featuresContainer}>
            <div className={styles.currentPlanHeader}>
                <p className={styles.planHeading}>{t('jobseekerFeatures.title', 'Features')}</p>
            </div>
            <div className={styles.selectedPlanContainer}>
                <div className={styles.planHeader}>
                    <div className={styles.renewal}>{planName || t('billing.planName')}</div>
                </div>
                <div className={`${styles.activeContainer} ${isPaused ? styles.pausedLink : styles.activeLink}`}>
                    <span>{isPaused ? t('billing.pausedStatus', 'Paused') : t('billing.activeStatus')}</span>
                </div>
            </div>
            <div className={styles.featuresDataList}>
                {featuresData.map((item, index) => (
                    <div key={index} className={styles.data}>
                        <p className={styles.name}>{item.name}</p>
                        <div className={styles.valueContainer}>
                            <div className={styles.value}>{item.value}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default JobseekerFeaturesUi; 